import { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';

import { AppContext } from 'commons-ui';

import useService from '../../../useService';

import { FORM_FIELD_CONFIG, FORM_FIELD_KEYS, getFormDefaults } from '../../formConfig';

const useCreate = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);
	const history = useHistory();
	const data = getFormDefaults();
	const { requestCreateSubAppUpdateInfo, getVersionNumberFromKey, filterVersionCodesByGameName } = useService();

	const gameNameValueDependencyResolver = (props: any, dependencyValues: string[]) => {
		const selectedGameName: string = dependencyValues[0]?.toLowerCase();
		let filteredResults = filterVersionCodesByGameName(selectedGameName);
		if (!filteredResults) {
			filteredResults = [];
		}
		return { options: filteredResults, disabled: false };
	};

	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.VERSION_NUMBER].setRenderProps({ dependencyResolver: gameNameValueDependencyResolver });

	const createSubAppUpdateInfo = async (createdData: any) => {
		setShowLoader(true);
		try {
			const selectedVersionKey: string = createdData.versionCode;
			const finalFormData = { ...createdData };
			finalFormData.versionCode = getVersionNumberFromKey(selectedVersionKey);
			await requestCreateSubAppUpdateInfo(finalFormData);
			showAlert('App Update Info created');
			history.goBack();
		} catch (error: any) {
			showAlert(`Error: ${error.response.data.error}`, { type: 'error' });
		} finally {
			setShowLoader(false);
		}
	};

	const handleFormSubmit = (submittedData: any) => {
		createSubAppUpdateInfo(submittedData);
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useCreate;
